import styled, { css } from 'styled-components';
import { Popup, Checkbox } from '../styled';

export const Content = styled.div`
  & .popup {
    top: 39px;
    background-color: #fff;
    border: solid 1px #bebebe;
  }
  & .checkbox {
    label {
      color: #000;
    }
    input {
      border: solid 1px #bebebe;
      padding: 0;
    }
  }
  & .input {
    padding: 0 9px;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      & .popup {
        background-color: #4f5761;
      }
      & .checkbox {
        label {
          color: #fff;
        }
        input {
          border: solid 1px #bebebe;
          padding: 0;
        }
      }
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      & .popup {
        top: 44px;
        background-color: var(--cp-surface);
        color: var(--cp-text);
        border-color: var(--cp-border);
      }
      & .checkbox label {
        color: var(--cp-text);
      }
    `}
`;

export const StyledPopup = styled(Popup)`
  width: fit-content;
  padding: 20px 10px;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  &.checkbox {
    input {
      margin-right: 8px;
    }
    label {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin: 0;
      font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
    }
  }
`;
export const RacksBox = styled.div`
  display: flex;
  align-items: center;
  & > div {
    margin-right: 17px;
  }
`;
export const NodeBox = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    margin-bottom: 14px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const InputBox = styled.div`
  position: relative;
  height: 100%;
  cursor: pointer;
  input {
    background-color: #fff;
    text-overflow: ellipsis;
  }
  &:after {
    /* z-index: 1; */
    content: '';
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -6px;
    width: 6px;
    height: 6px;
    border: 2px solid #6e7a86;
    border-width: 0 2px 2px 0;
    transform-origin: center;
    transform: rotate(45deg);
    transition: all 0.15s ease-in;
  }
  ${(props) =>
    props.$popupIsOpen &&
    css`
      &:after {
        margin-top: -3px;
        transform: rotate(225deg);
      }
    `}
  ${(props) =>
    props.theme.ui === 'v2' &&
    props.$popupIsOpen &&
    css`
      input {
        box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.15);
        border-color: var(--cp-accent, #47b972) !important;
      }
    `}

${(props) =>
    (props.theme.theme === 'dark' || props.theme.ui === 'v2') &&
    css`
      input {
        background-color: var(--cp-surface);
        color: var(--cp-text);
      }
    `}
`;
export const InputContent = styled.div`
  height: 100%;
  position: relative;
`;
